export default __webpack_public_path__ + "static/media/dinner1.c0ef3479.jpeg";